// Maps a list of ids against a {id, name} catalog and returns the matched names, dropping any
// id no longer present in the catalog. Shared by CategoryRow (linked option chips),
// useExportPlanningMachines (options column), and DetailActionDialog (managed vs free-text
// option split) — all three resolve `option_ids` against a catalog the same way.
export function resolveNamesByIds<T extends { id: string; name: string }>(ids: string[], catalog: T[]): string[] {
  return ids
    .map((id) => catalog.find((item) => item.id === id)?.name)
    .filter((name): name is string => !!name);
}
